import { useLayoutEffect, useEffect } from 'react';

import IS_BROWSER from '@picsart/rc/isBrowser';

const isomorphicUseEffect = IS_BROWSER ? useLayoutEffect : useEffect;

export default isomorphicUseEffect;
